export default __webpack_public_path__ + "img/sg_members_dinner_2022-ebc8c0c01a9d28fc91ad2fe3c6c60961.png";